// extracted by mini-css-extract-plugin
export default {"container":"drop-down_container__CkM5k","icon":"drop-down_icon__Hy6IY"};